import Transactions from "@/components/layout/my-deposits/Transactions";
import Statistics from "@/components/layout/my-deposits/Statistics";

const MyDeposits = () => {
  return (
    <div className="flex-1 flex flex-col items-center px-4 pt-4 gap-5">
      <Statistics />

      <Transactions />
    </div>
  );
};

export default MyDeposits;
